
import { useEffect, useRef } from "react";

/**
 * Custom hook untuk auto logout user jika tidak ada aktivitas selama timeoutMinutes.
 * @param onLogout Fungsi yang dipanggil saat timeout (biasanya signOut)
 * @param timeoutMinutes Durasi idle sebelum logout (default: 30 menit)
 * @param isActive Hanya aktifkan auto logout jika true (misal: user login)
 */
export function useAutoLogout(
  onLogout: () => void,
  timeoutMinutes: number = 30,
  isActive: boolean = true
) {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!isActive) {
      if (timerRef.current) clearTimeout(timerRef.current);
      return;
    }

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        onLogout();
      }, timeoutMinutes * 60 * 1000);
    };

    // Event listeners untuk aktivitas user
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    events.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer(); // Mulai timer saat mount

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [onLogout, timeoutMinutes, isActive]);
}
